import React, { useState, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GoEye } from "react-icons/go";
import { setAppError } from "../../../../store/userSlice";
import SmartDownloadPagination from "../../../../components/SmartDataTable/SmartDownloadPagination";
import nodeinstance from "../../../../nodeInstance";
import { checkAccessFn } from "../../../../utils/checkAccess";
import {
  FINAL_EXIT_COLUMNS,
  FINAL_EXIT_CONFIG,
  FINAL_EXIT_SEARCHABLE_FIELDS
} from './FinalExitListConstants';

const FinalExitList = ({ setId, setPropsData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) => checkAccessFn(dashboardData, module, name);
  const token = localStorage.getItem("nodeToken");

  const [trigger, setTrigger] = useState(0);

  // Data tracking state for UI optimization
  const [dataState, setDataState] = useState(() => ({
    hasData: false,
    isLoading: true,
    totalRecords: 0
  }));

  // Data load handler to track data availability
  const handleDataLoad = useCallback((data, pagination) => {
    const dataExists = data && data.length > 0;
    setDataState({
      hasData: dataExists,
      isLoading: pagination.isLoading,
      totalRecords: pagination.totalRecords || 0
    });
  }, []);

  // Navigate to details page
  const viewDetails = useCallback((item) => {
    setId(item.candidate_id);
    setPropsData(item);
    navigate(`/dashboard/final-exit/details/${item.candidate_id}`);
  }, [setId, setPropsData, navigate]);

  // Custom cell renderer - OPTIMIZED with useCallback
  const renderCustomCell = useCallback((item, column, rowIndex, currentPage, pageSize) => {
    if (column.key === 'serial') {
      return (currentPage - 1) * pageSize + rowIndex + 1;
    }

    if (column.key === 'visa_provider') {
      return item.visa_provider || item.Overseas_visa_provider || "-";
    }

    if (column.key === 'salary_placeholder') {
      return "-";
    }

    if (column.key === 'action') {
      return (
        <div
          className="ml-2 cursor-pointer"
          onClick={() => viewDetails(item)}
        >
          <GoEye fontSize={22} className="ml-2" />
        </div>
      );
    }

    return null;
  }, [viewDetails]);

  // Download handlers - OPTIMIZED with useCallback
  const handleDownloadComplete = useCallback((result) => {
    dispatch(setAppError({
      msg: `Excel Downloaded (${result.recordCount} records)`,
      color: "success",
    }));
  }, [dispatch]);

  const handleDownloadError = useCallback((error) => {
    dispatch(setAppError({
      msg: error.message || "Download failed",
      color: "error"
    }));
  }, [dispatch]);

  return (
    <>
      <SmartDownloadPagination
        // API Configuration
        apiEndpoint={FINAL_EXIT_CONFIG.API_ENDPOINT}
        downloadEndpoint={FINAL_EXIT_CONFIG.DOWNLOAD_ENDPOINT}
        token={token}

        // Table Configuration
        columns={FINAL_EXIT_COLUMNS}
        searchableFields={FINAL_EXIT_SEARCHABLE_FIELDS}
        layoutType="table"
        enableHighlighting={true}

        // Pagination Configuration
        defaultPageSize={FINAL_EXIT_CONFIG.DEFAULT_PAGE_SIZE}
        pageSizeOptions={FINAL_EXIT_CONFIG.PAGE_SIZE_OPTIONS}

        // Download Configuration
        downloadFilename={FINAL_EXIT_CONFIG.DOWNLOAD_FILENAME}
        enableDownload={true}

        // Search Configuration
        enableSearch={true}
        searchPlaceholder={FINAL_EXIT_CONFIG.SEARCH_PLACEHOLDER}
        searchDebounceMs={FINAL_EXIT_CONFIG.DEBOUNCE_MS}

        // Custom Actions
        customActions={[]}

        // Customization
        renderCustomCell={renderCustomCell}

        // Event Handlers
        onDataLoad={handleDataLoad}
        onDownloadComplete={handleDownloadComplete}
        onDownloadError={handleDownloadError}

        // Additional Props
        noDataMessage={FINAL_EXIT_CONFIG.NO_DATA_MESSAGE}
        className="final-exit-table"

        trigger={trigger}
      />
    </>
  );
};

export default FinalExitList;
